export const AlertType = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;
export type AlertType = (typeof AlertType)[keyof typeof AlertType];
